import React from 'react';

export interface DocNavItem {
  title: string;
  slug: string;
}

export interface DocHeading {
  id: string;
  text: string;
  level: number;
}

interface DocsSidebarProps {
  pages: DocNavItem[];
  activeSlug: string | null;
  headings: DocHeading[];
  activeHeadingId?: string | null;
  onNavigate: (slug: string) => void;
}

export function DocsSidebar({ pages, activeSlug, headings, activeHeadingId, onNavigate }: DocsSidebarProps) {
  return (
    <aside className="flex flex-col gap-1">
      {pages.map((page) => {
        const isActive = activeSlug === page.slug;
        return (
          <div key={page.slug} className="flex flex-col">
            <button
              type="button"
              onClick={() => onNavigate(page.slug)}
              className={`rounded-standard px-2 py-1 text-left text-sm leading-relaxed transition-colors ${
                isActive
                  ? 'text-text-primary'
                  : 'text-text-tertiary hover:text-text-primary'
              }`}
            >
              {page.title}
            </button>

            {isActive && headings.length > 0 && (
              <div className="ml-2 flex flex-col gap-0.5 pl-2 pt-1 pb-2">
                {headings.map((heading) => (
                  <a
                    key={heading.id}
                    href={`#${heading.id}`}
                    className={`rounded-standard px-2 py-0.5 text-left text-caption leading-relaxed transition-colors ${
                      activeHeadingId === heading.id
                        ? 'text-text-primary'
                        : 'text-text-quaternary hover:text-text-secondary'
                    } ${heading.level === 3 ? 'pl-4' : ''}`}
                  >
                    {heading.text}
                  </a>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </aside>
  );
}
